import { apiErrorCode } from '@/lib/api';

// The front desk's failures, in Portuguese. The API answers in English with a
// stable code; what staff read is decided here.

const MESSAGES: Record<string, string> = {
  AlreadyCheckedIn: 'Este participante já está num centro.',
  ParticipantNotActive:
    'O registo deste participante não está ativo. Se for menor, falta o consentimento do encarregado de educação.',
  NoActiveVisit: 'Este participante não está em nenhum centro.',
  EquipmentInUse: 'O participante ainda tem equipamento. Regista a devolução antes de terminar a visita.',
  EquipmentNotFound: 'Equipamento não encontrado.',
  EquipmentUnavailable: 'Este equipamento não está disponível.',
  NotOwner: 'Todas as unidades deste equipamento estão em uso.',
  BadgeRequired: 'O participante não tem a credencial que este equipamento exige.',
  NothingToDo: 'Já estava feito. A lista foi actualizada.',
  NotInCentre: 'O participante não está no centro deste equipamento.',
};

/**
 * What to tell staff when a front desk action fails. Never the API's own
 * message: an unknown failure gets `fallback`.
 */
export function presenceErrorMessage(err: unknown, fallback: string): string {
  const code = apiErrorCode(err);
  return (code && MESSAGES[code]) || fallback;
}

/** Where the participant already is, from a 409 AlreadyCheckedIn. */
export function activeVisitCentre(err: unknown): string | null {
  if (apiErrorCode(err) !== 'AlreadyCheckedIn') return null;
  const body = (err as { body?: unknown }).body as
    | { activeVisit?: { digitalCenterName?: unknown } }
    | undefined;
  const name = body?.activeVisit?.digitalCenterName;
  return typeof name === 'string' && name ? name : null;
}
